import moveItemsToBossUnavailableList from '@tcp/core/src/queries/moveItemsToBossUnavailable.query.graphql';
import getBossUnavailableListItems from '@tcp/core/src/queries/getBossUnavailableListItems.query.graphql';
import removeUnavailableListItems from '@tcp/core/src/queries/removeItemBossUnavailable.query.graphql';
import getConvertedBossUnavailableItems from '@tcp/core/src/queries/getConvertedBossUnavailableItems.query.graphql';

// import CacheConfiguration from '@tcp/core/src/services/handler/graphQL/clients/retryConfiguration';
import { getBrand, isCanada } from '../../../utils';
import { executeStatefulGraphQLQuery } from '../../handler';
import { AVAILABILITY, imageGenerator } from './CartItemTile';
import { getFormattedError } from '../../../utils/errorMessage.util';

const getFinalPDPUrl = (item) => {
  let pdpURL;
  if (getBrand()?.toUpperCase() === item?.product?.brand) {
    pdpURL = `us/p/${item?.product?.masterId}`;
  } else {
    pdpURL = `/p/${item?.product?.masterId}`;
  }
  return pdpURL;
};

const formatResponse = (product) => {
  const formattedArray = [];
  product?.forEach((item) => {
    formattedArray.push({
      productInfo: {
        generalProductId: item.id,
        skuId: item.id,
        name: item?.product?.name,
        pdpUrl: getFinalPDPUrl(item),
        color: {
          name: item.product.c_TCPColor,
        },
        isGiftCard: item?.product?.c_isGiftCard,
        itemBrand: item?.product.brand,
        Quantity: item.quantity,
        tcpStyleTypeOriginal: item?.c_TCPStyleType,
        seoToken: item.c_seoToken || item.product.pageKeywords,
        size: item.product.c_size,
        fit: item.product.c_fit,
        upc: item.product.upc,
      },
      itemInfo: {
        itemId: item?.id,
        offerPrice: item?.product?.price,
        listPrice: item?.product?.price,
        imagePath: imageGenerator(item?.product?.masterId)
          ? imageGenerator(item?.product?.masterId)?.productImages[500]
          : '',
        color: {
          name: item.product.c_TCPColor,
          imagePath: imageGenerator(item?.product?.masterId)
            ? imageGenerator(item?.product?.masterId)?.productImages[500]
            : '',
        },
        itemBrand: item?.product.brand,
        quantity: item.quantity,
        wasPrice: item?.c_list_price,
        price: item?.product?.price,
      },
      skuInfo: {
        skuId: item.product.upc,
        upc: item.product.upc,
        imageUrl: imageGenerator(item?.product?.masterId)
          ? imageGenerator(item?.product?.masterId)?.productImages[500]
          : '',

        colorProductId: item.product.c_TCPColor,
        color: {
          name: item.product.c_TCPColor,
          imagePath: imageGenerator(item?.product?.masterId)
            ? imageGenerator(item?.product?.masterId)?.productImages[500]
            : '',
        },
        fit: item.product.c_fit,
        size: item.product.c_size,
        productId: item.product.id,
        variantId: item.product.id,
        unbxdProdId: item?.product?.masterId,
        quantity: item.quantity,
        prodPartNo: item?.product?.masterId,
        variantNo: item?.product?.manufacturerSku,
        TCPProductIndStore: !isCanada()
          ? item?.product.c_TCPProductIndUSStore
          : item?.product.c_TCPProductIndCanadaStore,
      },
      miscInfo: {
        availability: item?.product.inventory?.ats !== 0 ? AVAILABILITY.OK : AVAILABILITY.SOLDOUT,
        c_accessories: item?.c_accessories,
        c_priceIncluded: item?.c_priceIncluded,
        c_mainProducts: item?.c_mainProducts,
        c_customizationType: item?.c_customizationType,
        TCPProductIndStore: !isCanada()
          ? item?.product.c_TCPProductIndUSStore
          : item?.product.c_TCPProductIndCanadaStore,
        clearanceItem: !isCanada()
          ? item?.product.c_TCPProductIndUSStore === 'Clearance'
          : item?.product.c_TCPProductIndCanadaStore === 'Clearance',
        isHardMarkEnabled: !isCanada()
          ? item?.product?.c_isHardMarkEnabledUS
          : item?.product?.c_isHardMarkEnabledCA,
      },
    });
  });
  return formattedArray;
};

const formatData = (item) => {
  return {
    productId: item.productId,
    imagePath: imageGenerator(item?.cProdPartNo)
      ? imageGenerator(item?.cProdPartNo)?.productImages[500]
      : '',
    itemBrand: item?.brand,
    cProdPartNo: item?.cProdPartNo,
  };
};

const moveItemsToBossUnavailable = (payload) => {
  return executeStatefulGraphQLQuery({
    query: moveItemsToBossUnavailableList,
    variables: {
      moveBasketItemsToListRequest: {
        unavailableItemList: payload,
      },
    },
    type: 'mutation',
  })
    .then((res) => {
      const responseToProcess = res?.data?.moveItemsToBossUnavailableList?.customerProductListItems;
      const responseFormatted = formatResponse(responseToProcess);
      return { data: responseFormatted, listId: res?.data?.moveItemsToBossUnavailableList?.id };
    })
    .catch((error) => {
      throw getFormattedError(error);
    });
};

export const fetchBossUnavailableProducts = () => {
  // const { prefix, defaultTTL } = CacheConfiguration.GET_BOSS_UNAVAILABLE_ITEMS;
  return executeStatefulGraphQLQuery({
    query: getBossUnavailableListItems,
    variables: {},
    // cacheConfigKey: `${prefix}`,
    // TTL: defaultTTL,
  })
    .then((res) => {
      const responseToProcess = res?.data?.getBossUnavailableListItems?.customerProductListItems;
      const responseFormatted = formatResponse(responseToProcess);
      return { data: responseFormatted, listId: res?.data?.getBossUnavailableListItems?.id };
    })
    .catch((error) => {
      throw getFormattedError(error);
    });
};

export const removeBossUnavailableProducts = (payload) => {
  return executeStatefulGraphQLQuery({
    query: removeUnavailableListItems,
    variables: payload,
    type: 'mutation',
  })
    .then((res) => {
      const responseToProcess =
        res?.data?.removeItemFromBossUnavailableList?.customerProductListItems;
      const responseFormatted = formatResponse(responseToProcess);
      return { data: responseFormatted, listId: res?.data?.removeItemFromBossUnavailableList?.id };
    })
    .catch((error) => {
      throw getFormattedError(error);
    });
};

export const getConvertedBossUnavailableProducts = () => {
  return executeStatefulGraphQLQuery({
    query: getConvertedBossUnavailableItems,
    variables: {},
  })
    .then((res) => {
      const formattedBasketItemData = [];
      const formattedRemovedItemData = [];
      if (res?.data?.convertBossUnavailableListToBasket?.basketItems) {
        res?.data?.convertBossUnavailableListToBasket?.basketItems?.forEach((item) => {
          formattedBasketItemData.push(formatData(item));
        });
      }
      if (res?.data?.convertBossUnavailableListToBasket?.removedItems) {
        res?.data?.convertBossUnavailableListToBasket?.removedItems?.forEach((item) => {
          formattedRemovedItemData.push(formatData(item));
        });
      }
      return { basketItems: formattedBasketItemData, removedItems: formattedRemovedItemData };
    })
    .catch((error) => {
      throw getFormattedError(error);
    });
};

export default moveItemsToBossUnavailable;
